import type { SVGProps } from 'react';
const DawnFlagPR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-PR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-PR_svg__a)">
      <path
        fill="#FA2222"
        fillRule="evenodd"
        d="M0 0h22v3.2H0zm0 6.4h22v3.2H0zm0 6.4V16h22v-3.2z"
        clipRule="evenodd"
      />
      <path
        fill="#1D63F9"
        fillRule="evenodd"
        d="m0 0 10.476 8L0 16z"
        clipRule="evenodd"
      />
      <g filter="url(#dawn-flag-PR_svg__b)">
        <path
          fill="url(#dawn-flag-PR_svg__c)"
          fillRule="evenodd"
          d="m3.667 9.02-1.54 1.137.588-1.842-1.539-1.14h1.902l.589-1.842.588 1.842h1.903l-1.539 1.14.587 1.842z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-PR_svg__c"
        x1={1.048}
        x2={1.048}
        y1={5.333}
        y2={10.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F0F0F0" />
      </linearGradient>
      <filter
        id="dawn-flag-PR_svg__b"
        width={4.982}
        height={5.824}
        x={1.176}
        y={5.333}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1476" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1476" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagPR;
